var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.6665 12.2187C2.29984 12.2187 1.98606 12.0883 1.72517 11.8274C1.46428 11.5665 1.33362 11.2525 1.33317 10.8854V2.21875H0.666504V0.885417H3.99984V0.21875H7.99984V0.885417H11.3332V2.21875H10.6665V10.8854C10.6665 11.2521 10.5361 11.5661 10.2752 11.8274C10.0143 12.0887 9.70028 12.2192 9.33317 12.2187H2.6665ZM9.33317 2.21875H2.6665V10.8854H9.33317V2.21875ZM3.99984 9.55208H5.33317V3.55208H3.99984V9.55208ZM6.6665 9.55208H7.99984V3.55208H6.6665V9.55208Z",
    fill: "#C8685A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.ad7ffb3094fcff2cee2b44b13e967aa6.svg";
export { ForwardRef as ReactComponent };